import React, { useState, useEffect } from 'react';
import { Resource } from '../../../types/EducationHub';
import { useEducationHub } from '../../../contexts/EducationHubContext';
import styles from '../../../styles/EducationHub.module.css';
import LoadingSpinner from 'components/common/LoadingSpinner';

const ResourcesSection: React.FC = () => {
  const { resources, resourcesLoading: loading, fetchResources, downloadResource } = useEducationHub();
  const [selectedCategory, setSelectedCategory] = useState<string>('');

  useEffect(() => {
    fetchResources({ limit: 50 });
  }, [fetchResources]);

  const filteredResources = resources.filter(resource => {
    if (selectedCategory && resource.category !== selectedCategory) return false;
    return true;
  });

  const categories = Array.from(new Set(resources.map(r => r.category)));

  const handleDownload = async (resource: Resource, e: React.MouseEvent) => {
    e.stopPropagation();
    await downloadResource(resource._id, { suggestedFilename: resource.doc_name, fileType: resource.fileType });
  };

  const renderResourceCard = (resource: Resource) => {
    return (
      <div key={resource._id} className={`${styles.contentCard} ${styles.resourceCard}`}>
        <div className={styles.cardHeader}>
          <h3 className={styles.cardTitle}>
            {resource.fileType === 'PDF' && '📄 '}
            {resource.fileType === 'DOCX' && '📝 '}
            {resource.fileType === 'XLSX' && '📊 '}
            {resource.doc_name}
          </h3>
        </div>
        
        <div className={styles.cardBody}>
          <div className={styles.cardMeta}>
            <div className={styles.cardDate}>
              <span>📂 {resource.category}</span>
              {/* <span>{resource.fileType}</span> */}
            </div>
          </div>
        </div>

        <div className={styles.cardFooter}>
          <div style={{ marginTop: '16px', display: 'flex', gap: '12px' }}>
            <button
              className={styles.downloadBtn}
              onClick={(e) => handleDownload(resource, e)}
              >
              📥 Download
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <LoadingSpinner />
    );
  }

  if (resources.length === 0) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyIcon}>📚</div>
        <h3 className={styles.emptyTitle}>No Resources Available</h3>
        <p className={styles.emptyDescription}>
          Check back soon for educational materials and reference documents.
        </p>
      </div>
    );
  }

  return (
    <div>
      {/* Filters */}
      {categories.length > 0 && (
        <div className={styles.filterContainer}>
          <div className={styles.categoryFilterWrapper}>
            <label className={styles.categoryLabel}>Category:</label>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className={styles.categorySelect}
            >
              <option value="">All Categories</option>
              {categories.map(category => (
                <option key={category} value={category}>{category}</option>
              ))}
            </select>
          </div>
        </div>
      )}

      {/* Resource Grid */}
      <div className={styles.contentGrid}>
        {filteredResources.map(renderResourceCard)}
      </div>

      {filteredResources.length === 0 && (
        <div className={styles.emptyState}>
          <p>No resources found matching your filters.</p>
        </div>
      )}
    </div>
  );
};

export default ResourcesSection;
